/* PanelLogin.js */
/* @author: anghello */

import React, { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { Col, Row, Form, FormGroup, Button } from 'reactstrap';
import { useAuth } from '../../../context/auth/AuthContext';
import { toast } from 'react-toastify';
import Strings from '../../../translations/Translations';
import PasswordInput from './input/PasswordInput';
import ForgotPasswordModal from './ForgotPasswordModal';

export default function PanelLogin() {
  const history = useHistory();
  const { login, toggleLoading } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = useCallback(async ({ username, password }) => {
    setLoading(true);
    toggleLoading(true);
    username = username.toLowerCase();
    username = username.trim();

    try {
      await login({ username, password });
      setLoading(false);
      toggleLoading(false);
      toast.success(Strings('welcome'));
      history.replace('/dashboard');
    } catch (err) {
      setLoading(false);
      toggleLoading(false);
      const errorMessage = (err && err.message) ? err.message : Strings('error_has_ocurred');
      toast.error(errorMessage);
    }
  }, [login, history, setLoading, toggleLoading]);

  const [openForgotPasswordModal, setOpenForgotPasswordModal] = useState(false);
  const toggleForgotPasswordModal = useCallback(() => {
    setOpenForgotPasswordModal(value => !value);
  }, []);

  return (
    <>
      <div className='mb-2 mb-0'>
        <small className="text-muted">&nbsp;</small>
      </div>

      <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Row>
          <Col md={12}>
            <FormGroup>
              <input
                type='text'
                name='username'
                placeholder={Strings('username_email')}
                {...register('username', { required: true })}
                className='form-control pb-input-1 border-radius-4px'
                autoCapitalize='none'
              />
              {errors && errors.username && errors.username.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('username_is_required')}</p>
              )}
            </FormGroup>
          </Col>
          <Col md={12}>
            <FormGroup>
              <PasswordInput
                name='password'
                placeholder={Strings('password')}
                {...register('password', { required: true })}
                className='form-control pb-input-1 border-radius-4px'
              />
              {errors && errors.password && errors.password.type === 'required' && (
                <p role='alert' className='text-danger txt-small-1'>{Strings('password_is_required')}</p>
              )}
            </FormGroup>
          </Col>
        </Row>

        <div className='mt-2 mb-2 d-flex justify-content-end'>
          <a
            className='p'
            href='/#'
            onClick={(evt) => {
              evt.preventDefault();
              toggleForgotPasswordModal();
            }}
          >
            {Strings('forgot_your_password')}
          </a>
        </div>

        <Row>
          <div className='d-flex justify-content-center'>
            <Button
              className='pb-btn-1'
              type='submit'
              onClick={handleSubmit(onSubmit)}
              loading={loading}
              disabled={loading}
            >
              {Strings('login')}
            </Button>
          </div>
        </Row>
      </Form>

      <ForgotPasswordModal
        isOpen={openForgotPasswordModal}
        toggle={toggleForgotPasswordModal}
      />
    </>
  );
}
